import { CustomerEmailConsumer } from '@cex-newsletter/aws-amplify/src/models';
import { useAppRoutes as useAdminAppRoutes } from './routes-admin';
import { useAppRoutes as useJessAppRoutes } from './routes-jess';

export const useAppRoutes = {
    [CustomerEmailConsumer.JESS_DAVIS]: useJessAppRoutes
}[process.env.REACT_APP_CONSUMER] ?? useAdminAppRoutes;
